import React from 'react';
import cn from 'classnames';
import styles from './Icons.module.scss';
import { addStyle } from './utils';

export const Icon = ({ iconName, size, onClick, spinning, className }) => (
  <i
    tabIndex={addStyle(!!onClick, 0)}
    role={addStyle(!!onClick, 'button')}
    onClick={onClick}
    className={cn(
      styles.icon,
      'fas',
      `fa-${iconName}`,
      styles[size],
      size,
      addStyle(!!onClick, styles.clickable),
      spinning ? 'fa-spin' : null,
      className
    )}
  />
);

Icon.defaultProps = {
  size: 'sm',
};

export const SearchIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='search' onClick={onClick} />
);

export const SettingsIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='cog' onClick={onClick} />
);

export const OrdersIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='list' onClick={onClick} />
);

export const OrderIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='shopping-cart' onClick={onClick} />
);

export const CheckIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='check' onClick={onClick} />
);

export const WhiteCheckIcon = ({ size, onClick }) => (
  <Icon
    className={styles.white}
    size={size}
    iconName='check'
    onClick={onClick}
  />
);

export const PlusCircleIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='plus-circle' onClick={onClick} />
);

export const CloseIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='times' onClick={onClick} />
);

export const CopyIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='copy' onClick={onClick} />
);

export const PasteIcon = ({ size, disabled, onClick }) => (
  <Icon size={size} iconName='paste' className={disabled === true ? styles.gray : styles.black } onClick={onClick} />
);

export const SyncIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='sync' onClick={onClick} />
);

export const SaveIcon = ({ size, onClick, disabled }) => (
  <Icon size={size} iconName="save" onClick={onClick} className={disabled === true ? styles.black : styles.gray } />
);

export const EmptyIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='folder-open' onClick={onClick} />
);

export const EditIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='edit' onClick={onClick} />
);

export const InfoCircleIcon = ({ size, onClick }) => (
  <Icon
    className={styles.infoCircleIcon}
    size={size}
    iconName='info-circle'
    onClick={onClick}
  />
);

export const CloseContentIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='caret-right' onClick={onClick} />
);

export const OpenContentIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='caret-down' onClick={onClick} />
);

export const SpinnerIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='spinner' spinning onClick={onClick} />
);

export const LogoutIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='power-off' onClick={onClick} />
);

export const IconPlaceholder = () => <div style={{ minHeight: 24 }} />;

export const BarcodeIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='barcode' onClick={onClick} />
);

export const CloudDownloadIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='cloud-download-alt' onClick={onClick} />
);

export const VisibilityIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='eye' onClick={onClick} />
);

export const NonVisibilityIcon = ({ size, onClick }) => (
  <Icon size={size} iconName='eye-slash' onClick={onClick} />
);
